import React, { Component } from 'react';
import { InputGroup, InputGroupAddon, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import styles from './NumberInput.scss';

export default class NumberInput extends Component {
  static propTypes = {
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
  };

  static defaultProps = {
    min: 1,
    max: 200,
    disabled: false,
  }

  handleIncrementBtn = () => {
    if (this.props.value + 1 <= this.props.max) {
      this.props.onChange(this.props.value + 1);
    }
  }

  handleDecrementBtn = () => {
    if (this.props.value - 1 >= this.props.min) {
      this.props.onChange(this.props.value - 1);
    }
  }

  handleInputChange = (param) => {
    const newValue = parseInt(param.target.value);
    if(!isNaN(newValue) && newValue >= this.props.min && newValue <= this.props.max) {
      this.props.onChange(newValue);
    }
  }

  render() {
    return (
      <InputGroup size="sm">
        <InputGroupAddon addonType="prepend">
          <Button onClick={this.handleDecrementBtn} color="secondary" disabled={this.props.disabled || this.props.value === this.props.min}>
            <i className="fa fa-minus" aria-hidden="true"></i>
          </Button>
        </InputGroupAddon>
        <input
          value={this.props.value}
          type="text"
          onChange={this.handleInputChange}
          className={`form-control ${styles.input}`}
          disabled={this.props.disabled}
        />
        <InputGroupAddon addonType="append">
          <Button onClick={this.handleIncrementBtn} color="secondary" disabled={this.props.disabled}>
            <i className="fa fa-plus" aria-hidden="true"></i>
          </Button>
        </InputGroupAddon>
      </InputGroup>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/NumberInput.jsx